import { errorToast } from 'v2/utils/toasts'

// Embed mounts no console banners, so a Test agent that cannot start says why here.
export const embedTestErrorToast = (description: string) =>
  errorToast({ title: 'Unable to start the test', description })

// Embed has no profile to read a balance from; the runner still checks it before AI nodes.
export const shouldGateOnBalance = (prod: boolean, embed: boolean): boolean => prod && !embed
